import { Coverage } from "../enums/Coverage";
import { BenefitOption } from "./BenefitOption";
import { State } from "../enums/State";
import { BenefitStatus } from "../enums/BenefitStatus";
import { DateTime } from "luxon";
import { EvidenceOfInsurabilityStatus } from "../enums/EvidenceOfInsurabilityStatus";
import { EmployeeAssistanceProgram } from "../generated/graphql";

export interface Benefit {
    coverage: Coverage,
    approvedAmount: number,
    pendingAmount: number,
    accidentalDeathAndDismembermentApprovedAmount?: number,
    accidentalDeathAndDismembermentPendingAmount?: number,
    contractState: State,
    status: BenefitStatus,
    effectiveDate: string,
    terminationDate: string,
    employeeAssistanceProgramProvision?: EmployeeAssistanceProgram,
    benefitOptions: BenefitOption[],
    evidenceOfInsurabilityStatus?: EvidenceOfInsurabilityStatus,
    evidenceOfInsurabilityUrl?: string
}

export namespace Benefit {
    export function isTerminated(benefit: Benefit): boolean {
        return (DateTime.fromISO(benefit.terminationDate) <= DateTime.now()
            && benefit.status === BenefitStatus.TERMINATED);
    }
}